import { Reducer } from "redux"
import { KolFiltersState, RESET_KOL_FILTERS, SET_KOL_FILTERS } from "../actions/kolFilters"

const initialState: KolFiltersState = {
  social_platform_code: [],
  categories_code: [],
  age_groups: [],
  gender_codes: [],
  talent_manager_ids: [],
  tiers: [],
  payment_status: [],
  profile_status: [],
}

type Action =
  | { type: typeof SET_KOL_FILTERS; payload: Partial<KolFiltersState> }
  | { type: typeof RESET_KOL_FILTERS }

export const kolFiltersReducer: Reducer<KolFiltersState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case SET_KOL_FILTERS:
      return { ...state, ...action.payload }
    case RESET_KOL_FILTERS:
      return initialState
    default:
      return state
  }
}
